import Slipbox from './slipbox.vue'
export default Slipbox



// WEBPACK FOOTER //
// ./src/components/slipbox/index.js